<template>
  <layout>
    <page-header>
      <template slot="header">
        <h4 class="mr-4">
          <i class="icon-percent mr-2"></i>
          {{ $t('partners.commissions_title') }}
        </h4>
      </template>
    </page-header>
    <div class="content">
      <commissions-notice />
      <b-card v-if="$account && $account.partner">
        <div>
          {{ $t('partners.your_partner_id') }}:
          <strong>{{ $account.id }}</strong>
        </div>
        <div>
          {{ $t('partners.your_current_commission') }}:
          <strong>{{ $account.partner_commission }}%</strong>
        </div>
      </b-card>
      <b-card no-body>
        <div class="card-body">
          <button
            v-if="isPending"
            class="btn btn-primary mr-2"
            @click="generateInvoice"
          >
            {{ $t('partners.generate_invoice') }}
          </button>
          <span class="mr-2">
            {{ $t('partners.unprocessed_bookings', { count: totals.count }) }}
          </span>
          <span v-if="isPending">
            {{ $t('partners.bookings_amount') }}:
            <b>{{ totals.bookings_amount | currency(currency_label) }}</b>
            / {{ $t('partners.partner_amount') }}:
            <b>{{ totals.partner_amount | currency(currency_label) }}</b>
          </span>
        </div>

        <b-table ref="table" v-bind="tableProps">
          <template #bookings="{ item }">
            <span v-for="booking in item.bookings" :key="booking.id">
              <router-link
                v-if="$allows('administer')"
                :to="{ name: 'bookings.edit', params: { id: booking.id } }"
              >
                #{{ booking.number }}
              </router-link>
              <span v-else>#{{ booking.number }}</span>
              <span class="text-sm text-muted">
                ({{ booking.partner_commission }}%)
              </span>
            </span>
          </template>
          <template #bookings_amount="{ item }">
            {{ item.bookings_amount | currency(currency_label) }}
          </template>
          <template #partner_amount="{ item }">
            {{ item.partner_amount | currency(currency_label) }}
          </template>
        </b-table>
      </b-card>
    </div>
  </layout>
</template>

<script>
import { AdminTable } from 'stylemix-vue-admin'
import CommissionsApi from './CommissionsApi'
import BookingAmount from '../bookings/BookingAmount'
import CommissionsNotice from './CommissionsNotice'
import ValueDate from '../components/values/ValueDate'
import OrderFinalAmount from '../orders/OrderFinalAmount'

export default {
  name: 'Commissions',

  components: {
    AdminTable,
    BookingAmount,
    CommissionsNotice,
    OrderFinalAmount,
    ValueDate,
  },

  data() {
    return {
      currency: null,
      currency_label: null,
      totals: {},
      total_payments: {},

      // Table resource configuration
      tableProps: {
        items: () => {
          return new CommissionsApi()
            .setParameters({
              partner_id: this.$route.params.partner_id,
            })
            .all()
            .then(result => {
              this.onApiResult(result)
              return result.data
            })
        },
        fields: [
          {
            key: 'bookings',
            label: 'Bookings',
          },
          {
            key: 'bookings_amount',
            label: this.$t('partners.bookings_amount'),
          },
          {
            key: 'partner_amount',
            label: this.$t('partners.partner_amount'),
            class: 'font-bold',
          },
        ],
      },
    }
  },

  computed: {
    isPending() {
      return this.totals.count > 0
    },
  },

  methods: {
    onApiResult(result) {
      this.currency = result.currency
      this.currency_label = result.currency_label
      this.unprocessed = result.unprocessed
      this.totals = result.totals
      this.total_payments = result.total_payments
    },
    generateInvoices() {
      this.$uiBlocker(
        this.$http.post('partner/process').then(response => {
          this.$toast.success(response.data.message)
          this.unprocessed = response.data.unprocessed
        }),
        this.$refs.table,
      )
    },
    async generateInvoice() {
      const { value } = await this.$alert.question(
        this.$t('partners.request_now_confirm'),
        '',
        {
          showCancelButton: true,
        },
      )

      if (value) {
        new CommissionsApi()
          .process([], this.$route.params.partner_id)
          .then(result => {
            this.$toast.success(result.message)
            this.unprocessed = result.unprocessed
            this.$refs.table.refresh()
          })
          .catch(response => {
            this.$toast.error(response.data.message)
          })
      }
    },
  },
}
</script>
